import React, { memo, useEffect, useState } from "react";
import Layout from "../components/Layout";
import { code55Items } from "../data/code55Data";
import logo from "../assets/images/logo00.webp";
import { fruits } from "../components/HeroSection/floatingItems";
import "./style.css";

const facts = [
  "Оригинальные шведские технологии",
  "2 вида крепости",
  "25 пакетиков в банке",
  "4 вкуса — Crispy Mint, Royal Mint, Fresh Mint, Ice Cool",
];

const RotatingFact = ({ isHomepage }) => {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % facts.length);
        setVisible(true);
      }, 400);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full flex flex-col items-center gap-4 py-8">
      {/* Dots */}
      <div className="flex gap-2">
        {facts.map((_, i) => (
          <span
            key={i}
            className="block rounded-full transition-all duration-500"
            style={{
              width: i === idx ? 24 : 8,
              height: 8,
              background: i === idx ? "#ffffff" : "#ffffff",
            }}
          />
        ))}
      </div>

      {/* Text */}
      <p
        className={
          isHomepage
            ? "text-center font-semibold tracking-wide text-xl xl:text-4xl"
            : "text-center font-semibold tracking-wide text-lg xl:text-4xl"
        }
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(8px)",
          transition: "opacity 0.4s ease, transform 0.4s ease",
          color: "#ffffff",
          minHeight: "2.5rem",
        }}
      >
        {facts[idx]}
      </p>
    </div>
  );
};

const ItemTile = ({ item }) => (
  <div className="group relative aspect-square overflow-hidden rounded-xl">
    <img
      src={item.fone}
      alt=""
      className="absolute inset-0 w-full h-full object-cover opacity-90"
      style={{ transform: `rotate(${item.rotate})` }}
      aria-hidden="true"
    />

    <img
      src={item.img}
      alt={item.title}
      className={`absolute inset-0 w-full h-full object-contain ${
        item.id === "menthol-strong" || item.id === "mango-mint"
          ? "swing-left"
          : "swing-right"
      }`}
      draggable={false}
    />

    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 opacity-0 group-hover:opacity-100 text-center">
      <span className="product-badge">{item.title}</span>
    </div>
  </div>
);

const Code190Page = memo(({ isHomepage = false }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const content = (
    <>
      <div className="fixed mb-4 top-8 left-4 sm:top-6 sm:left-6 z-20 flex flex-col items-center space-y-1" />
      <section className="relative px-4 sm:px-8 md:px-12">

        {/* Logo section — только на отдельной странице */}
        {!isHomepage && (
          <div className="w-full h-full flex justify-center items-center relative">
            <div className="relative inline-block">
              <div className="logo-wrapper">
                <img src={logo} alt="Main Logo" className="main-logo" />
                {fruits.map((f) => (
                  <img
                    key={f.id}
                    src={f.src}
                    alt={f.alt}
                    className="fruit-img"
                    style={{
                      top: f.top,
                      left: f.left,
                      width: f.size,
                      zIndex: f.zIndex || 1,
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Заголовок */}
          <div className="max-w-7xl mx-auto flex flex-col items-center text-center pt-16 pb-6">
            <h2
              className="font-black uppercase leading-none"
              style={{
                fontSize: "clamp(2.5rem, 8vw, 5rem)",
                letterSpacing: "-0.02em",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
              }}
            >
              Жевательный табак
            </h2>
            <h2
              className="font-black uppercase leading-none mt-1"
              style={{
                fontSize: "clamp(3rem, 10vw, 6.5rem)",
                letterSpacing: "-0.02em",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
              }}
            >
              CODE
            </h2>

            <RotatingFact isHomepage={true} />
          </div>

        {/* Грид продуктов */}
        <div
            className={
              isHomepage
                  ? "flex sm:grid sm:grid-cols-2 lg:grid-cols-4 overflow-x-auto sm:overflow-visible gap-6 mb-8 pb-4 max-w-7xl mx-auto"
                  : "max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-12 mb-8"
            }
        >
          {code55Items.map((it) => (
              <div
                  key={it.id}
                  className={isHomepage ? "flex-shrink-0 sm:flex-shrink w-[350px] h-[350px] sm:w-auto sm:h-auto" : ""}
              >
                <ItemTile item={it}/>
              </div>
          ))}
        </div>
      </section>
    </>
  );

  return isHomepage ? content : <Layout>{content}</Layout>;
});

export default Code190Page;
